const Fun = () => {
  return (
    <div>Fun</div>
  )
}

export default Fun